import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { mockCargoCategories } from '../mockData';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Footer = () => {
  const [content, setContent] = useState({
    companyName: 'Truckn Send It Pty Ltd',
    copyright: 'Copyright © 2025 Truckn Send It Pty Ltd'
  });

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const response = await axios.get(`${API}/cms/content/footer`);
      setContent({
        companyName: response.data.company_name?.value || content.companyName,
        copyright: response.data.copyright?.value || content.copyright,
      });
    } catch (error) {
      console.log('Using default footer content');
    }
  };

  return (
    <footer className="bg-[#1e3a5f] text-white">
      <div className="container mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 sm:gap-12 mb-12">
          {/* Contact Us */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-4">Contact Us</h3>
            <div className="space-y-2 text-sm sm:text-base">
              <a href="tel:1300380700" className="block hover:text-orange-400 transition-colors">
                1300 380 700
              </a>
              <a href="mailto:info@trucknsendit.com" className="block hover:text-orange-400 transition-colors">
                info@trucknsendit.com
              </a>
            </div>

            <h3 className="text-base sm:text-lg font-bold mt-6 sm:mt-8 mb-4">Follow Us</h3>
            <div className="flex gap-4">
              <a 
                href="https://www.facebook.com/profile.php?id=61580895101388" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-orange-400 transition-colors"
                aria-label="Facebook"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a 
                href="https://www.instagram.com/Trucknsendit" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-orange-400 transition-colors"
                aria-label="Instagram"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links - right side */}
          <div className="sm:text-right">
            <h3 className="text-base sm:text-lg font-bold mb-4">Quick Links</h3>
            <div className="space-y-2 text-sm sm:text-base">
              <a 
                href="https://customer-assets.emergentagent.com/job_aussihauling/artifacts/88612hwh_TRUCKN%20SEND%20IT%20TERMS%20OF%20SERVICE.pdf" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block hover:text-orange-400 transition-colors"
              >
                Terms of Service
              </a>
              <a 
                href="https://customer-assets.emergentagent.com/job_ceea8302-9252-4ab3-9bf5-6b9d3f265946/artifacts/c2f5296l_Truckn%20Send%20It%20Privacy%20Policy.pdf" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block hover:text-orange-400 transition-colors"
              >
                Privacy Policy
              </a>
              <Link to="/admin/login" className="block hover:text-orange-400 transition-colors">
                Admin Login
              </Link>
            </div>
          </div>
        </div>
        
        {/* Bottom Section */}
        <div className="border-t border-white/20 pt-6 sm:pt-8">
          <p className="text-xs sm:text-sm text-gray-300 text-center">
            {content.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;